<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Xem chi tiết nhật ký yêu cầu báo cáo</strong>
                    </div>
                    <div>
                      <b-row>
                        <b-col sm="6">
                          <b-form-group label="Tài khoản yêu cầu:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ reportRequest.requestUserName}}</label>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group label="Ngày yêu cầu:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ reportRequest.requestedDate|formatTime }}</label>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6">
                          <b-form-group label="Loại yêu cầu:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ reportRequest.isSuddenRequest ? 'Đột xuất' : 'Định kỳ' }}</label>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6" v-if="!reportRequest.isSuddenRequest">
                          <b-form-group label="Tên cấu hình định kỳ:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ reportRequest.reportRequestParameterName  }}</label>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="6">
                          <b-form-group label="Mẫu báo cáo:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ $store.getters.getReportSyncTypeName(reportRequest.reportTypeId) }}</label>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group label="Ngày báo cáo:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ getReportDate(reportRequest) }} </label>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="6">
                          <b-form-group label="Nguồn báo cáo:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ reportRequest.syncDataSourceName }}</label>
                          </b-form-group>

                        </b-col>
                        <b-col sm="6">
                          <b-form-group label="Trạng thái:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{$store.getters.getReportRequestStatusName(reportRequest.status)  }}</label>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col md="6">
                          <b-form-group label="Đường dẫn yêu cầu xuất báo cáo:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label style="word-break: break-all;" class="col-form-label">{{ reportRequest.requestUrl }}</label>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group label="Tài khoản yêu cầu:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ reportRequest.requestUserName  }}</label>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="6">
                          <b-form-group label="ID trả về từ service nhận yêu cầu báo cáo:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ reportRequest.requestId }}</label>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group label="Đơn vị yêu cầu:"
                                        label-for="input-unit"
                                        :label-cols="4"
                                        :horizontal="true"
                                        label-align="left">
                            <label class="col-form-label">{{ reportRequest.reportUnitName  }}</label>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <div class="form-group row">
                        <label class="col-4 col-md-2 text-left" style="padding-right: 3px">Dữ liệu gốc:</label>
                        <div class="col-8 col-md-10">
                          <json-viewer :data="reportRequest.rawData"></json-viewer>
                        </div>
                      </div>

                      <div class="form-group row" v-if="reportRequest.errorMessage">
                        <label class="col-4 col-md-2 text-left" style="padding-right: 3px">Thông tin lỗi:</label>
                        <div class="col-8 col-md-10">
                          <json-viewer :data="reportRequest.errorMessage"></json-viewer>
                        </div>
                      </div>
                    </div>
                    <div class="text-center">
                        <b-button type="button" variant="primary" :to="{ path: `/logs/sync/reports/${reportRequest.reportSyncLogId}` }" v-if="reportRequest.reportSyncLogId">Xem chi tiết báo cáo</b-button>

                        <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'
    import { mapState } from 'vuex'

    export default {
        name: 'ListAssetSource',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    filter: null
                },
                gridOptions: {
                    fields: [

                    ],
                    sortBy: 'isValid',
                },
                reportRequest: {

                },
                tableInfos: {
                    columns: [],
                    groups: []
                },
                detailsShowing: false,
                isShowHandlingType: false,
                isShowInfrastructureAssetType: false
            }
        },
        computed: {
            logId() {
                return this.$route.params.logId;
            },
            groups() {

            },
            ...mapState({
                tableComments: (state) => state.common.tableComments
            })
        },
        created() {
            this.loadLogDetail();
        },
        methods:
        {
            loadLogDetail() {
                var vm = this;
                var getters = vm.$store.getters;

                return this.$services.get(`logging/request-logs/${this.logId}`).done(data => {

                    vm.reportRequest = data;


                });
            },
            getReportDate(report) {

                if (report.reportTypeId) {

                    var reportType = this.$store.getters.getReportSyncType(report.reportTypeId);
                    var format = defaultDisplayFormatDate;
                    switch (reportType.periodType) {
                        case 1: return formatDate(report.reportEndDate, format);
                        case 2: return `${formatDate(report.reportStartDate, format)} - ${formatDate(report.reportEndDate, format)}`;
                        case 3: return report.reportYear ? `31/12/${report.reportYear}` : '';
                    }
                }
            },
            getReportUrl(data) {


            },
        },
        watch: {
            logId() {
                this.loadLogDetail();;
            }
        }
    }
</script>
<style scoped>
    .tableFixHead {
        overflow-y: auto;
    }

        .tableFixHead thead th {
            position: sticky;
            top: 0;
        }

    /* Just common table stuff. Really. */
    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 8px 16px;
    }

    th {
        background: #eee;
    }
</style>
